/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ 3 Nov 2026 · THE CURRENCY A NEW RECORD STARTS IN — the workspace's base.   │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * The product owner: *"every currency picker preselects the workspace's base currency"*. The base
 * is `workspace_currencies.is_default` (`0126`); `GET /workspace/currencies` lists it first
 * (`currency.service.ts` orders `is_default desc`), so a list that dropped the flag on the way still
 * answers correctly through the fallback.
 *
 * ⚠️ **One helper, so no dialog guesses again.** Before it, one picker preselected nothing, one
 * hardcoded `HUF`, and two recognised the base by `rateToBase === '1.00000000'` — which is also true
 * of any currency somebody pegged one-to-one.
 *
 * ⚠️ A surface whose record belongs to something with its OWN currency — a line item's cost or
 * invoice — prefers that one and falls back to this (`economics.currencyCode ?? base`).
 */
export function baseCurrencyOf<T extends { readonly code: string; readonly isDefault?: boolean }>(
  currencies: readonly T[],
): T | undefined {
  return currencies.find((one) => one.isDefault === true) ?? currencies[0];
}
